import { Close } from '@mui/icons-material';
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../../../context/ConfigContext';
import { Restaurant } from '../../../../interfaces/Catalogue';
import { LoyaltyArticle } from '../../../../interfaces/loyality.interface';
import ImageLazyLoader from '../../../common/ImageLazyLoader';
import './LoyaltyRedemptionModal.scss';
import { lightenColor } from '../../../../utils/colorsUtils';

interface LoyaltyRedemptionModalProps {
  visible: boolean;
  item: LoyaltyArticle | null;
  restaurant: Restaurant;
  onClose: () => void;
  onRedeem: (item: any) => void;
}

export const LoyaltyRedemptionModal: React.FC<LoyaltyRedemptionModalProps> = ({
  visible,
  item,
  restaurant,
  onClose,
  onRedeem,
}) => {
  const { config } = useConfig();
  const navigate = useNavigate();
  const modalRef = useRef<HTMLDivElement>(null);
  const isAnimatingRef = useRef(false);
  const primaryColor = config?.primaryColor || '#6366F1';

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
      isAnimatingRef.current = true;

      setTimeout(() => {
        isAnimatingRef.current = false;
      }, 600);
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [visible]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && visible) {
        handleClose();
      }
    };

    if (visible) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible]);

  const handleClose = () => {
    if (isAnimatingRef.current) return;
    onClose();
  };

  const handleRedeem = () => {
    if (isAnimatingRef.current) return;

    const button = document.querySelector('.redemption-button');
    if (button) {
      button.classList.add('clicked');
      setTimeout(() => {
        button.classList.remove('clicked');
      }, 300);
    }

    setTimeout(() => {
      navigate(`restaurant/${restaurant.id}`);
      onRedeem(item);
    }, 100);
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!item || !visible) return null;

  return (
    <div
      className={`loyalty-redemption-modal ${visible ? 'visible' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className="modal-overlay">
        <div
          ref={modalRef}
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="close-button-loyalty-modal"
            onClick={handleClose}
            aria-label="Fermer"
          >
            <Close className="close-icon" />
          </button>

          <div className="modal-body">
            {item.image && (
              <div className="image-container">
                <ImageLazyLoader
                  src={item.image}
                  alt={item.name}
                  className="modal-image"
                  effect="blur"
                />
              </div>
            )}

            <h2 className="modal-title-loyalty">
              {item.name}
            </h2>

            <div
              className="promo-container"
              style={{
                background: `linear-gradient(90deg, ${primaryColor}22, ${primaryColor}11)`

              }}
            >
              <div className="shimmer-container">
                <div className="shimmer-overlay" />
              </div>

              <div className="promo-icon">🎉</div>
              <h3 className="promo-title">Offre Exclusive Fidélité !</h3>
              <p className="promo-text">
                Vous pouvez bénéficier d'une réduction de{' '}
                <span className="highlight">
                  {item.discountPercent}%
                </span>
                {' '}sur le prix de cet article en échange de{' '}
                <span className="highlight">
                  {item.pointsRequired} points
                </span>
                {' '}de fidélité.
              </p>
            </div>

            <div className="button-container-loyalty">
              <button
                className="redemption-button"
                onClick={handleRedeem}
              >
                <span className="button-text-redemption">
                  Consulter l'article
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};